import { render, staticRenderFns } from "./Cannon20_Regular.vue?vue&type=template&id=442c2820&"
import script from "./Cannon20_Regular.vue?vue&type=script&lang=js&"
export * from "./Cannon20_Regular.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports